import React from 'react';
import { SidebarProvider, SidebarContent } from '@ka/webcomponents/nav';
import { Site } from '../../requests/employee/useGetSites';
import { KAEmployeeTopBar } from './KAEmployeeTopBar';
import { KAEmployeeNavSideMenu } from './KAEmployeeNavSideMenu';

const KAEmployeeLayout: React.FC<{ children?: React.ReactNode, sites: Site[] }> = ({ children, sites }) => {
  return (
    <SidebarProvider>
      <KAEmployeeTopBar sites={sites} />
      <main id="content" role="main" className="navbar-sidebar-aside navbar-sidebar-aside-sm portal-content">
        <KAEmployeeNavSideMenu />
        <SidebarContent className="content-space-t-1 content-space-b-2 px-lg-5 px-xl-10 portal-content-body d-flex flex-column">
          {children}
        </SidebarContent>
      </main>
    </SidebarProvider>
  );
}

export { KAEmployeeLayout };
